import ReactGA from 'react-ga';

export interface ProductGA {
  id: string;
  description: string;
  value: number;
  quantity: number;
}

export const addProductToGA = (products?: ProductGA[]) => {
  if (products && products.length > 0) {
    products.forEach((product, idx) => {
      ReactGA.ga('ec:addProduct', {
        id: product.id,
        name: product.description,
        price: product.value,
        quantity: product.quantity,
        position: idx + 1,
      });
    });
  }
};

export const setActionToGA = (step: number) => {
  ReactGA.ga('ec:setAction', 'checkout', { step });
};
